import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { setAuth, setOrdCond, setToast } from '../../containers/client/actions';
// import { stockDetailRequest } from '../modal/stockDetail/actions';

import {
  makeGetToken,
  makeGetAuth,
  makeGetListOrderCond,
  makeGetCondDetail,
} from '../../lib/selector';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { Col, Button } from 'react-bootstrap';

import {
  numberFormat,
  _convertActTypeToStr,
  _getOrdCondStatus,
  _getOrderStatus,
  _getOrdCondStr,
  formatDate,
} from '../../utils';

import { find, isEqual } from 'lodash';
import { FaExternalLinkAlt, FaTimesCircle } from 'react-icons/fa';

import {
  listCondRequest,
  detailCondRequest,
  cancelCondRequest,
} from '../modal/ordCond/actions';
import FormDeleteOrdCond from '../modal/order/deleteOrdCond';
import { v4 as uuidv4 } from 'uuid';
import PaginationTable from '../PaginationTable';
import { ReloadButton } from '../btnReload';
import { translate } from 'react-i18next';
class LenhDieuKien extends React.PureComponent {
  state = {
    ordSel: null,
    order: null,
    showModalDel: false,
    listOrderToShow: [],
  };

  componentDidMount() {
    const { account } = this.props;
    if (account) this._handleLoadListOrder();
  }

  _handleLoadListOrder = () => {
    const { token, account } = this.props;

    const expireddt = new Date();
    expireddt.setDate(expireddt.getDate() + 7);

    const createddt = new Date();
    createddt.setDate(createddt.getDate() - 30);

    if (account) {
      const uuid = uuidv4();

      const params = {
        group: 'ORS',
        cmd: 'getOrsOrderList',
        user: token.user,
        session: token.session,
        rqId: uuid,
        channel: 'WTS',
        data: {
          acntNo: account.acntNo,
          subAcntNo: account.subAcntNo,
          ordertype: 'CNL',
          createddt: formatDate(createddt, '-'),
          expireddt: formatDate(expireddt, '-'),
        },
      };

      this.props.dispatch(listCondRequest(params));
    }
  };

  componentDidUpdate(preProps) {
    const {
      account,
      condCancelSuccessful,
      condCancelErrors,
      listOrder,
    } = this.props;

    if (!isEqual(listOrder, preProps.listOrder)) {
      this.setState({ listOrderToShow: listOrder || [] });
    }

    if (account && account !== preProps.account) {
      this.setState({ ordSel: null });
      this._handleLoadListOrder();
    }

    if (
      condCancelSuccessful &&
      condCancelSuccessful !== preProps.condCancelSuccessful
    ) {
      this.setState({ ordSel: null });
      this._handleLoadListOrder();

      this._handleToast('Huỷ lệnh điều kiện thành công');
    }

    if (
      !condCancelSuccessful &&
      !!condCancelErrors.length &&
      condCancelErrors !== preProps.condCancelErrors
    ) {
      // this.setState({ ordSel: null });
      this._handleLoadListOrder();

      this._handleToast(condCancelErrors[0].body);

      console.log(condCancelErrors);
    }
  }

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
    };
    this.props.dispatch(setToast(toastMsg));
  };

  _handleOrderDetail = (record) => {
    const { token, account } = this.props;
    if (!record || !record.ordrNo) return;
    if (account) {
      const uuid = uuidv4();

      const resData = {
        group: 'ORS',
        cmd: 'getOrsOrderDetail',
        user: token.user,
        session: token.session,
        rqId: uuid,
        channel: 'WTS',
        data: {
          subAcntNo: account.subAcntNo,
          ordrNo: record.ordrNo + '',
        },
      };
      this.props.dispatch(detailCondRequest(resData));
    }

    this.setState({ ordSel: record });
  };

  _handleAuthen = () => {
    this.props.dispatch(setAuth());
  };

  _handleDeleteOrder = (orderNo) => {
    console.log(orderNo);
    const { listOrder } = this.props;

    const order = find(listOrder, (o) => o.ordrNo === orderNo);
    if (order) {
      console.log(order);
      this.setState({ showModalDel: true, order });
    }
  };

  _handleSubmitDeleteOrder = (order) => {
    const { token, auth, account } = this.props;
    const uuid = uuidv4();

    const params = {
      group: 'ORS',
      user: token.user,
      session: token.session,
      cmd: 'cancelOrsOrder',
      type: auth.type,
      token: auth.token,
      rqId: uuid,
      channel: 'WTS',
      data: {
        acctno: account.acntNo,
        subAcntNo: account.subAcntNo,
        orderid: order.ordrNo + '',
        msgtype: 'CNL',
        symbol: order.symbol,
      },
    };

    this.props.dispatch(cancelCondRequest(params));

    this.setState({ showModalDel: false, order: null });
  };

  _handleCloseModalDel = () => {
    this.setState({ showModalDel: false, order: null });
  };

  _handleOpenOrdCond = () => {
    const { auth } = this.props;
    if (auth && auth.isVerified) {
      this.props.dispatch(setOrdCond(true));
    } else {
      this._handleAuthen();
    }
  };

  render() {
    const { account, condDetail, auth, listOrder, t } = this.props;
    const { ordSel, order, showModalDel, listOrderToShow } = this.state;
    // console.log('account', account);
    // console.log('ordSel', ordSel);

    // console.log('listOrder', listOrder)

    const columns = [
      {
        key: 'side',
        text: t('txt-trade-acronym'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          return (
            <div
              className={
                'text-uppercase mx-auto trade_side_' +
                (record.side === 'B' ? '1' : '2')
              }
            >
              {record.side === 'B' ? t('txt-buy') : t('txt-sell')}
            </div>
          );
        },
      },
      {
        key: 'symbol',
        text: t('txt-symbol'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'ordrNo',
        text: t('txt-order-no'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'createddt',
        text: t('txt-label-from'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'expireddt',
        text: t('txt-label-to'),
        className: 'text-center',
        align: 'center',
      },
      {
        key: 'activetype',
        text: t('txt-label-condition'),
        className: 'text-left',
        align: 'center',
        cell: (record) => {
          return _convertActTypeToStr(record.activetype);
        },
      },
      {
        key: 'qtty',
        text: t('txt-vol'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.qtty, 0, '0');
        },
      },
      {
        key: 'status',
        text: t('txt-status'),
        className: (record) => {
          return 'text-center ordStt_' + record.status;
        },
        align: 'center',
        cell: (record) => {
          return _getOrdCondStatus(record.status);
        },
      },
      {
        key: 'ordertype',
        text: t('txt-match-vol'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.execQtty, 0, '0');
          // return _getOrdCondStr(record.ordertype);
        },
      },
    ];

    console.log(condDetail);

    return (
      <Fragment>
        <PerfectScrollBar style={{ height: 'calc( 100% - 50px )' }}>
          <div className="d-flex flex-row">
            <Col className="d-flex flex-column pr-0">
              <div className="d-flex flex-row mt-3 mb-2">
                <span className="text-white" style={{ fontSize: '18px' }}>
                  {`${t('txt-order-cond')}:`}
                </span>
                &nbsp;
                <span className="mr-auto font-weight-bold text-white fz-18">
                  {account &&
                    account.value +
                      ' - ' +
                      (account.value.startsWith('M')
                        ? 'Margin'
                        : t('txt-normal'))}
                </span>
                <Button
                  variant="primary"
                  className="fz-14 mr-2 "
                  onClick={this._handleOpenOrdCond}
                  style={{ height: '26px', padding: '0 15px' }}
                >
                  {t('txt-btn-order-cond')}
                  <FaExternalLinkAlt
                    className="fz-12 ml-1"
                    style={{ padding: '1px' }}
                  />
                </Button>
                <ReloadButton
                  type="button"
                  className="mr-3 btn-reload"
                  onClick={() => this._handleLoadListOrder()}
                />
              </div>
              <PaginationTable
                tblClassName="tbl-list"
                divClassName="mt-2"
                onRowClicked={this._handleOrderDetail}
                pageSize={15}
                columns={columns}
                source={listOrderToShow}
              />
            </Col>
            <Col className="d-flex flex-column">
              {ordSel && (
                <Fragment>
                  <div className="d-flex flex-row mt-3 mb-3">
                    <span className="text-white fz-18">
                      {_getOrdCondStr(ordSel.ordertype)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center flex-row pt-2 pb-2 bt-1-half">
                    <span className="text-white fz-18">{ordSel.symbol}</span>
                    &nbsp;
                    <div
                      className={
                        'fz-14 text-uppercase trade_side_' +
                        (ordSel.side === 'B' ? '1' : '2')
                      }
                    >
                      {ordSel.side === 'B' ? t('txt-buy') : t('txt-sell')}
                    </div>
                    <span className="mr-auto ml-2 fz-18 text-white ">
                      {`SHL: ${ordSel.ordrNo}`}
                    </span>
                    <span className={'fz-14 pl-2 ordStt_' + ordSel.status}>
                      {_getOrdCondStatus(ordSel.status)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center flex-row pt-2 pb-2 bt-1-half">
                    <label className="fz-14 text-white text-uppercase mr-auto">
                      {t('txt-label-condition')}
                    </label>
                    <div>
                      {auth && auth.isVerified ? (
                        <Fragment>
                          {['I', 'E', 'F'].indexOf(ordSel.status) > -1 ? (
                            <label className="text-muted d-inline-block fz-14">
                              <FaTimesCircle
                                style={{
                                  paddingRight: '2px',
                                  marginRight: '2px',
                                }}
                              />
                              {t('txt-label-order-del')}
                            </label>
                          ) : (
                            <label
                              className="d d-inline-block fz-14"
                              onClick={() =>
                                this._handleDeleteOrder(ordSel.ordrNo)
                              }
                            >
                              <FaTimesCircle
                                style={{
                                  paddingRight: '2px',
                                  marginRight: '2px',
                                }}
                              />
                              {t('txt-label-order-del')}
                            </label>
                          )}
                        </Fragment>
                      ) : (
                        <Button
                          variant="warning"
                          className="fz-14"
                          style={{ height: '22px', padding: '0 15px' }}
                          onClick={() => this._handleAuthen()}
                        >
                          {t('txt-xacthuc')}
                        </Button>
                      )}
                    </div>
                  </div>
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td className="text-left bt-1-half w_125">
                          {t('txt-vol')}
                        </td>
                        <td className="text-left bt-1-half">
                          {condDetail &&
                            condDetail.cond &&
                            numberFormat(condDetail.cond.qtty, 0, '0')}
                        </td>
                      </tr>
                      {condDetail &&
                        condDetail.cond &&
                        condDetail.cond.ordertype !== 'PCO' && (
                          <tr>
                            <td className="text-left">{t('txt-ref')}</td>
                            <td className="text-left">
                              {condDetail &&
                                condDetail.cond &&
                                numberFormat(condDetail.cond.price, 0, '0')}
                            </td>
                          </tr>
                        )}
                      <tr>
                        <td className="text-left">{t('txt-price')}</td>
                        <td className="text-left">
                          {condDetail &&
                            condDetail.cond &&
                            numberFormat(condDetail.cond.price, 0, '0')}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {(!condDetail || !condDetail.cond) && (
                    <p className="text-center fz-14 mt-2 title-time">
                      {t('txt-no-data-found')}
                    </p>
                  )}
                </Fragment>
              )}
            </Col>
          </div>
          <div className=""></div>
        </PerfectScrollBar>
        {showModalDel && (
          <FormDeleteOrdCond
            order={order}
            showModal={showModalDel}
            handleCloseModal={this._handleCloseModalDel}
            handleSubmitOrder={this._handleSubmitDeleteOrder}
          />
        )}
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAuth = makeGetAuth();
  const getListOrderCond = makeGetListOrderCond();
  const getOrderCondDetail = makeGetCondDetail();

  const mapStateToProps = (state, props) => {
    return {
      token: getToken(state),
      auth: getAuth(state),
      listOrder: getListOrderCond(state),
      condDetail: getOrderCondDetail(state),
      condCancelSuccessful: state.ordCond.condCancelSuccessful,
      condCancelErrors: state.ordCond.condCancelErrors,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(LenhDieuKien)
);
